var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { InputSelect } from "../Input";
var TimePicker = function (_a) {
    var withTime = _a.withTime, hour = _a.hour, setHour = _a.setHour, minute = _a.minute, setMinute = _a.setMinute;
    var hrId = useId();
    var minId = useId();
    if (!withTime) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", __assign({ className: "flex justify-end mb-5" }, { children: _jsxs("div", __assign({ className: "flex flex-col gap-y-1" }, { children: [_jsx("strong", { children: withTime.messages.time }), _jsxs("div", __assign({ className: "flex items-center gap-x-1" }, { children: [_jsx(InputSelect, { id: hrId, displayName: withTime.messages.hour, options: Array(24).fill(0).map(function (_, i) { return ({
                                label: i < 10 ? "0".concat(i) : i,
                                value: i
                            }); }), defaultValue: hour, onChange: function (e) { return setHour && setHour(parseInt(e.target.value)); }, hideLabel: true }), _jsx("span", { children: ":" }), _jsx(InputSelect, { id: minId, displayName: withTime.messages.minute, options: Array(60).fill(0).map(function (_, i) { return ({
                                label: i < 10 ? "0".concat(i) : i,
                                value: i
                            }); }), defaultValue: minute, onChange: function (e) { return setMinute && setMinute(parseInt(e.target.value)); }, hideLabel: true })] }))] })) })));
};
export default TimePicker;
